import React from "react";
import "./ProfileCardHead1.css";

const experienceItems = [
  {
    year: 2023,
    title: "Solution Architect at",
    company: "Cognizant",
    description:
      "Architecting enterprise platforms across Azure, Dynamics 365, Power Platform, React, ArcGIS, and integration services, with a focus on public sector transformation, scalable delivery, and AI-ready solution design.",
  },
  {
    year: 2019,
    title: "Technical Specialist at",
    company: "Cognizant",
    description:
      "Delivered modern Microsoft-platform solutions using Azure, React, Python, and enterprise business applications, while improving engineering quality through CI/CD, reviews, and structured delivery standards.",
  },
  {
    year: 2018,
    title: "Technical Lead at",
    company: "LTI",
    description:
      "Led technical delivery across Microsoft-focused web platforms and cloud-connected services, helping teams modernize delivery practices and shape more maintainable solution design.",
  },
  {
    year: 2015,
    title: "Team Lead at",
    company: "AkzoNobel",
    description:
      "Built digital workplace and automation solutions, combining collaboration platforms, search-led experiences, and Azure services to improve usability, governance, and operational efficiency.",
  },
  {
    year: 2011,
    title: "Associate Programmer at",
    company: "Cognizant",
    description:
      "Started in enterprise delivery building and supporting Microsoft-based business solutions across development, migration, customization, deployment, and production support.",
  },
];

function ProfileCardHead1() {
  const buttons = document.querySelectorAll(".card-buttons button");

  const handleButtonClick = (event) => {
    const sections = document.querySelectorAll(".card-section");
    const card = document.querySelector(".card");
    const targetSection = event.target.getAttribute("data-section");
    const section = document.querySelector(targetSection);

    if (!card || !section) {
      return;
    }

    if (targetSection !== "#about") {
      card.classList.add("is-active");
    } else {
      card.classList.remove("is-active");
    }

    card.setAttribute("data-state", targetSection);
    sections.forEach((currentSection) => currentSection.classList.remove("is-active"));
    buttons.forEach((button) => button.classList.remove("is-active"));
    event.target.classList.add("is-active");
    section.classList.add("is-active");
  };

  const handleAboutClick = (event) => {
    const sections = document.querySelectorAll(".card-section");
    const card = document.querySelector(".card");
    const targetSection = event.target.getAttribute("data-section");
    const section = document.querySelector(targetSection);

    if (!card || !section) {
      return;
    }

    card.classList.add("is-active");
    card.setAttribute("data-state", targetSection);

    sections.forEach((currentSection) => {
      if (currentSection.id !== "about") {
        currentSection.classList.remove("is-active");
      } else {
        currentSection.classList.add("is-active");
      }
    });

    buttons.forEach((button) => {
      if (button.id !== "btnabout") {
        button.classList.remove("is-active");
      } else {
        button.classList.add("is-active");
      }
    });

    event.target.classList.add("is-active");
    section.classList.add("is-active");
  };

  return (
    <>
      <div className="card" data-state="#about">
        <div className="card-header">
          <div
            className="card-cover"
            style={{
              backgroundImage: "linear-gradient(135deg, #16324f, #1d4ed8, #0f766e)",
            }}
          />
          <img
            className="card-avatar"
            src={require("./image/praveenpic.jpg")}
            alt="avatar"
          />
          <h1 className="card-fullname">Praveenkumar Rajendran</h1>
          <h2 className="card-jobtitle">
            Solution Architect | Azure | AI | Dynamics 365 | Power Platform | React | Python
          </h2>
        </div>
        <div className="card-main">
          <div className="card-section is-active" id="about">
            <div className="card-content">
              <div className="card-subtitle">ABOUT</div>
              <p className="card-desc">
                I help organisations design and deliver modern digital platforms across Azure,
                Dynamics 365, Power Platform, React, Python, and enterprise integration. My
                work sits at the intersection of architecture, engineering, and business
                outcomes, turning complex requirements into secure, scalable, and AI-ready
                services that teams can actually operate and evolve with confidence.
              </p>
            </div>
            <div className="card-social">
              <a target="_blank" rel="noreferrer" href="https://twitter.com/Pravinmee">
                <svg className="profileTwitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M512 97.248c-19.04 8.352-39.328 13.888-60.48 16.576 21.76-12.992 38.368-33.408 46.176-58.016-20.288 12.096-42.688 20.64-66.56 25.408C411.872 60.704 384.416 48 354.464 48c-58.112 0-104.896 47.168-104.896 104.992 0 8.32.704 16.32 2.432 23.936-87.264-4.256-164.48-46.08-216.352-109.792-9.056 15.712-14.368 33.696-14.368 53.056 0 36.352 18.72 68.576 46.624 87.232-16.864-.32-33.408-5.216-47.424-12.928v1.152c0 51.008 36.384 93.376 84.096 103.136-8.544 2.336-17.856 3.456-27.52 3.456-6.72 0-13.504-.384-19.872-1.792 13.6 41.568 52.192 72.128 98.08 73.12-35.712 27.936-81.056 44.768-130.144 44.768-8.608 0-16.864-.384-25.12-1.44C46.496 446.88 101.6 464 161.024 464c193.152 0 298.752-160 298.752-298.688 0-4.64-.16-9.12-.384-13.568 20.832-14.784 38.336-33.248 52.608-54.496z" />
                </svg>
              </a>
              <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/pravin080317/">
                <svg className="profileLink" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.994 24v-.001H24v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07V7.976H8.489v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243V24zM.396 7.977h4.976V24H.396zM2.882 0C1.291 0 0 1.291 0 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909A2.884 2.884 0 002.882 0z" />
                </svg>
              </a>
              <a target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UCiLghwJGKyyDVse8v6bWOzg">
                <svg className="profileYoutube" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M567.28 143.22c-6.11-22.94-24.36-40.68-47.28-46.79C464.58 80 288 80 288 80S111.88 80 56.06 96.41C33.14 102.53 15 120.28 8.89 143.22 0 180.16 0 256 0 256s0 75.84 8.89 112.78c6.11 22.94 24.36 40.68 47.28 46.79C111.88 432 288 432 288 432s176.12 0 231.94-16.41c22.92-6.11 41.17-23.85 47.28-46.79C576 331.84 576 256 576 256s0-75.84-8.72-112.78z" fill="#f00" />
                  <path d="M405.16 265.42l-98.18 57.3c-19.17 11.22-35.44-2.91-35.44-22.91V212.89c0-20 16.27-34.13 35.44-22.91l98.18 57.3c16.46 9.64 16.46 33.06 0 42.7z" fill="#fff" />
                </svg>
              </a>
              <a target="_blank" rel="noreferrer" href="https://github.com/pravin080317">
                <svg className="profileGithub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M12 .3c-6.63 0-12 5.37-12 12 0 5.302 3.438 9.8 8.207 11.387.6.11.793-.258.793-.576 0-.284-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.388-1.333-1.756-1.333-1.756-1.089-.744.083-.729.083-.729 1.204.084 1.838 1.236 1.838 1.236 1.07 1.84 2.808 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.303-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.524.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.652.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.604-.015 2.896-.015 3.286 0 .318.187.693.8.575 4.77-1.588 8.203-6.085 8.203-11.387 0-6.63-5.373-12-12-12z" />
                </svg>
              </a>
            </div>
          </div>
          <div className="card-section" id="experience">
            <div className="card-content">
              <div className="card-subtitle">SELECTED EXPERIENCE</div>
              <div className="card-timeline">
                {experienceItems.map((item) => (
                  <div className="card-item" data-year={item.year} key={`${item.year}-${item.company}`}>
                    <div className="card-item-title">
                      {item.title} <span>{item.company}</span>
                    </div>
                    <div className="card-item-desc">{item.description}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="card-section" id="contact">
            <div className="card-content">
              <div className="card-subtitle">CONNECT</div>
              <div className="card-contact-wrapper">
                <div className="card-contact">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                  London, United Kingdom
                </div>
                <div className="card-contact">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <path d="M22 6l-10 7L2 6" />
                  </svg>
                  pravin080317@gmail.com
                </div>
                <div className="card-contact">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M16 8a6 6 0 016 6v6h-4v-6a2 2 0 00-4 0v6h-4v-12h4v2" />
                    <rect x={2} y={9} width={4} height={12} />
                    <circle cx={4} cy={4} r={2} />
                  </svg>
                  linkedin.com/in/pravin080317
                </div>
                <div className="card-contact">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="M2 12h20" />
                    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                  </svg>
                  dsynctech.com
                </div>
                <button className="contact-me">
                  <a href="https://www.linkedin.com/in/pravin080317/" target="_blank" rel="noreferrer">
                    WORK TOGETHER
                  </a>
                </button>
              </div>
            </div>
          </div>
          <div className="card-buttons">
            <button id="btnabout" data-section="#about" onClick={handleAboutClick} className="is-active">
              ABOUT
            </button>
            <button id="btnexperience" onClick={handleButtonClick} data-section="#experience">
              EXPERIENCE
            </button>
            <button id="btncontact" onClick={handleButtonClick} data-section="#contact">
              CONTACT
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileCardHead1;
